import Grid from "@material-ui/core/Grid";
import {Typography} from "@material-ui/core";
import React from "react";

export default function DeviceSettingsBlock({title, children}) {
    if (!children) return null;

    return (
        <Grid item xs={12} container spacing={2} justify={"space-between"} alignItems={"center"}>
            <Grid item xs={12}>
                <Typography align={"center"} color={"textSecondary"}>{title}</Typography>
            </Grid>
            {children}
        </Grid>
    );
}